import React, {useState} from 'react';
import {FlexColumn, Label, Modal} from '@forecast-it/design-system';
import {FormattedMessage, useIntl} from 'react-intl';
import Util from '../../shared/util/util';
import RichTextItem from '../../../components/richtext_item';
import UpdateClientMutation from '../../../mutations/update_client_mutation';
import styled from 'styled-components';

type RichTextWrapperProps = {
	minHeight?: number;
};

export const RichTextWrapper = styled.div<RichTextWrapperProps>`
	.editor {
		border-color: #6b6d7b;
		border-radius: 4px;
		&:hover {
			border-color: #6b6d7b;
		}
		&.client-notes-editor {
			margin: 0;
			.public-DraftEditor-content {
				min-height: ${({minHeight}) => (minHeight ? `${minHeight}px` : '0px')};
			}
		}
	}
`;

type EditNotesModalProps = {
	clientId: number;
	currentNotes: string;
	closeModal: () => void;
};

const EditNotesModal = ({clientId, currentNotes, closeModal}: EditNotesModalProps): JSX.Element => {
	const {formatMessage} = useIntl();
	const [notes, setNotes] = useState(currentNotes ?? '');

	const handleClientNotesUpdate = editorState => setNotes(editorState);
	const saveChanges = () =>
		Util.CommitMutation(
			UpdateClientMutation,
			{
				id: clientId,
				notes: notes,
			},
			closeModal
		);

	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id="settings_clients.edit_notes" />
			</Modal.Title>
			<Modal.Content>
				<FlexColumn>
					<Label>{formatMessage({id: 'settings_clients.client_notes'})}</Label>
					<RichTextWrapper minHeight={60}>
						<RichTextItem
							readOnly={false}
							text={notes}
							placeholder={formatMessage({id: 'settings_clients.enter_client_note'})}
							handleTextChange={handleClientNotesUpdate.bind(this)}
							hideEmojiPicker={true}
							alwaysShowControls={true}
							alwaysShowBorder={true}
							clientNotesEditor={true}
						/>
					</RichTextWrapper>
				</FlexColumn>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={saveChanges}>
					<FormattedMessage id={'common.save_changes'} />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id={'common.close'} />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default EditNotesModal;
